import "antd/es/row/style";
import _Row from "antd/es/row";
import "antd/es/divider/style";
import _Divider from "antd/es/divider";
import "antd/es/col/style";
import _Col from "antd/es/col";
import "antd/es/grid/style";
import _Grid from "antd/es/grid";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useReducer, useContext, useEffect, useCallback, cloneElement, isValidElement } from 'react';
import FormContext from '../../form-context';
import { calcNamePath, calcFormItemProps } from '../../utils/form-utils';
import Typography from '../../typography';
import Button from '../../button';
import { LocaleContext } from '../../locale';
import './style/index.less';
var useBreakpoint = _Grid.useBreakpoint;

var AddableSection = function AddableSection(props) {
  var name = props.name,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      _props$labelProps = props.labelProps,
      labelProps = _props$labelProps === void 0 ? {} : _props$labelProps,
      _props$contentProps = props.contentProps,
      contentProps = _props$contentProps === void 0 ? {} : _props$contentProps,
      _props$max = props.max,
      max = _props$max === void 0 ? Number.MAX_SAFE_INTEGER : _props$max,
      _props$initCount = props.initCount,
      initCount = _props$initCount === void 0 ? 1 : _props$initCount,
      _props$min = props.min,
      min = _props$min === void 0 ? initCount : _props$min,
      parentName = props.parentName,
      preview = props.preview,
      disabledFromParent = props.disabledFromParent,
      setShowStepButton = props.setShowStepButton,
      addButtonText = props.addButtonText,
      addButtonIcon = props.addButtonIcon,
      children = props.children,
      description = props.description;

  var _useBreakpoint = useBreakpoint(),
      md = _useBreakpoint.md;

  var _useReducer = useReducer(function (r) {
    return r + 1;
  }, 0),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _ = _useReducer2[0],
      dispatch = _useReducer2[1];

  var _useContext = useContext(LocaleContext),
      formatMessage = _useContext.formatMessage;

  var _useContext2 = useContext(FormContext),
      form = _useContext2.form,
      requiredMark = _useContext2.requiredMark,
      registerDependencies = _useContext2.registerDependencies;

  var namePath = calcNamePath(parentName, name);
  var reducer = useCallback(function (state, action) {
    if (action.type === 'add') {
      return [].concat(_toConsumableArray(state), [action.key]);
    }

    var found = false;
    return state.filter(function (key, index) {
      if (key === action.key) {
        found = true;
      }

      if (found) {
        if (index === state.length - 1) {
          form === null || form === void 0 ? void 0 : form.setFields([{
            name: calcNamePath(namePath, index),
            value: undefined
          }]);
        } else {
          form === null || form === void 0 ? void 0 : form.setFields([{
            name: calcNamePath(namePath, index),
            value: form.getFieldValue(calcNamePath(namePath, index + 1))
          }]);
        }
      }

      return key !== action.key;
    });
  }, []);

  var _useReducer3 = useReducer(reducer, function () {
    var init = [];
    var value = (form === null || form === void 0 ? void 0 : form.getFieldValue(namePath)) || [];

    for (var i = 0; i < Math.max(min, value.length, initCount); i++) {
      init.push(Date.now() + Math.random());
    }

    return init;
  }()),
      _useReducer4 = _slicedToArray(_useReducer3, 2),
      groupKeys = _useReducer4[0],
      dispath = _useReducer4[1];

  useEffect(function () {
    var dependencies = props.dependencies,
        asserts = props.asserts,
        copyValue = props.copyValue,
        selectValue = props.selectValue,
        shouldRender = props.shouldRender,
        subscribedFields = props.subscribedFields,
        disabled = props.disabled;
    var dependentField = dependencies || [];

    if (Array.isArray(subscribedFields)) {
      dependentField.push.apply(dependentField, _toConsumableArray(subscribedFields));
    }

    if (asserts && asserts.length) {
      asserts.forEach(function (_ref) {
        var field = _ref.field;
        return dependentField.push(field);
      });
    }

    if (copyValue) {
      dependentField.push(copyValue.assert.field);
    }

    if (selectValue && selectValue.length) {
      selectValue.forEach(function (_ref2) {
        var assert = _ref2.assert;
        return dependentField.push(assert.field);
      });
    }

    if (shouldRender && !Array.isArray(subscribedFields)) {
      dependentField.push('SUBSCRIBE_ALL');
    }

    if (Array.isArray(disabled)) {
      disabled.forEach(function (_ref3) {
        var field = _ref3.field;
        return dependentField.push(field);
      });
    } else if (_typeof(disabled) === 'object') {
      dependentField.push(disabled.field);
    }

    registerDependencies(dependentField, dispatch);
  }, []);

  var _calcFormItemProps = calcFormItemProps(props, {
    requiredMark: requiredMark
  }, form, parentName),
      formItemProps = _calcFormItemProps.formItemProps,
      elementProps = _calcFormItemProps.elementProps,
      display = _calcFormItemProps.display;

  if (formItemProps.copiedValue.copied) {
    var currentValue = form === null || form === void 0 ? void 0 : form.getFieldValue(namePath);

    var value = _objectSpread(_objectSpread({}, currentValue), formItemProps.copiedValue.value);

    form === null || form === void 0 ? void 0 : form.setFields([{
      name: namePath,
      value: value,
      errors: []
    }]);
  }

  var transformChildren = function transformChildren(parentName) {
    if (Array.isArray(children)) {
      return children.map(function (c, index) {
        var _c$type;

        var _child = _objectSpread({}, c.props);

        if (Array.isArray(_child.asserts)) {
          _child.asserts = _child.asserts.map(function (assert) {
            return _objectSpread(_objectSpread({}, assert), {}, {
              field: calcNamePath(parentName, assert.field)
            });
          });
        }

        if (Array.isArray(_child.requiredAsserts)) {
          _child.requiredAsserts = _child.requiredAsserts.map(function (assert) {
            return _objectSpread(_objectSpread({}, assert), {}, {
              field: calcNamePath(parentName, assert.field)
            });
          });
        }

        if (Array.isArray(_child.dependencies)) {
          _child.dependencies = _child.dependencies.map(function (path) {
            return calcNamePath(parentName, path);
          });
        }

        if (['Igloo_Free_Form_Item', 'Igloo_Free_Form_Section', 'Igloo_Free_Form_AddableSection'].includes(c === null || c === void 0 ? void 0 : (_c$type = c.type) === null || _c$type === void 0 ? void 0 : _c$type.displayName)) {
          return /*#__PURE__*/cloneElement(c, _objectSpread(_objectSpread({
            key: index
          }, _child), {}, {
            parentName: parentName,
            setShowStepButton: setShowStepButton,
            preview: preview,
            disabledFromParent: elementProps.disabled || disabledFromParent
          }));
        }

        return c;
      });
    }

    if ( /*#__PURE__*/isValidElement(children)) {
      var _child = _objectSpread({}, children.props);

      if (Array.isArray(_child.asserts)) {
        _child.asserts = _child.asserts.map(function (assert) {
          return _objectSpread(_objectSpread({}, assert), {}, {
            field: calcNamePath(parentName, assert.field)
          });
        });
      }

      if (Array.isArray(_child.requiredAsserts)) {
        _child.requiredAsserts = _child.requiredAsserts.map(function (assert) {
          return _objectSpread(_objectSpread({}, assert), {}, {
            field: calcNamePath(parentName, assert.field)
          });
        });
      }

      if (Array.isArray(_child.dependencies)) {
        _child.dependencies = _child.dependencies.map(function (path) {
          return calcNamePath(parentName, path);
        });
      }

      return /*#__PURE__*/cloneElement(children, _objectSpread(_objectSpread({}, _child), {}, {
        // @ts-ignore
        parentName: parentName,
        setShowStepButton: setShowStepButton,
        preview: preview,
        disabledFromParent: elementProps.disabled
      }));
    }

    return children;
  };

  if (!display) {
    return null;
  }

  var groups = groupKeys.map(function (key, index) {
    var parentName = calcNamePath(namePath, index);
    return _jsxs(_Col, {
      span: 24,
      className: 'igloo-addable-section',
      children: [index > 0 && _jsx(_Divider, {
        style: {
          margin: !md ? preview ? '16px 0 24px 0' : '24px 0' : preview ? '16px 0 24px' : '32px 0 24px 0'
        }
      }), (groupKeys.length > min && !preview || label) && _jsxs(_Row, {
        justify: "space-between",
        className: 'igloo-addable-section-label',
        children: [label ? _jsx(Typography, _objectSpread(_objectSpread({}, labelProps), {}, {
          level: !md ? 'body1' : 'h3b',
          wrapElement: "div",
          children: label
        })) : _jsx("div", {}), groupKeys.length > min && !preview && _jsx(Button, {
          type: "link",
          className: "igloo-addable-section-label-remove",
          onClick: function onClick() {
            return dispath({
              type: 'remove',
              key: key
            });
          },
          children: formatMessage({
            id: 'Remove'
          })
        })]
      }), _jsx("div", _objectSpread(_objectSpread({
        className: 'igloo-addable-section-content'
      }, contentProps), {}, {
        style: {
          marginTop: !md ? 16 : preview ? 16 : 24
        },
        children: _jsx(_Row, {
          gutter: [32, preview ? 16 : 24],
          children: transformChildren(parentName)
        })
      }))]
    }, key);
  });
  return _jsxs("div", {
    className: "igloo-addable-section-container",
    style: {
      width: '100%'
    },
    children: [groups, groupKeys.length < max && !preview && _jsxs(_Col, {
      span: 24,
      style: {
        marginTop: groups.length ? !md ? 24 : 32 : 0
      },
      children: [description && _jsx(Typography, {
        level: "body1",
        wrapElement: "div",
        style: {
          color: '#666666',
          marginBottom: 8,
          whiteSpace: 'pre-wrap'
        },
        children: description
      }), _jsx(Button, {
        onClick: function onClick() {
          return dispath({
            type: 'add',
            key: Date.now()
          });
        },
        className: "igloo-addable-section-button",
        icon: addButtonIcon,
        disabled: elementProps.disabled,
        children: addButtonText || "".concat(formatMessage({
          id: 'Add'
        }), " ").concat(label)
      })]
    })]
  });
};

export default AddableSection;
AddableSection.displayName = 'Igloo_Free_Form_AddableSection';